import { AxiosResponse } from 'axios';

enum SubgroupsPoints {
  GET_SUBGROUPS = 'event/groups/get',
}

interface IGetEventSubgroup {
  id: Id;
  event_id: string;
  url_code: string;
}

interface IGetEventSubgroups extends IGetEventSubgroup {
  name: string;
  teacher: string;
  age_to: string;
  age_from: string;
  size_min: string;
  size: string;
  is_pfdod: string;
  hours_year: string;
  date_start: string;
  date_end: string;
  is_locked: boolean;
  is_locked_next_year: boolean;
  available_order_current_year: boolean;
  available_order_next_year: boolean;
  available_next_year_order_from: StringOrNull;
  is_deleted: boolean;
  financing_source: StringOrNull;
  financing_cost: StringOrNull;
  program_name: string;
  program_status: string;
  is_event_locked: boolean;
  event_state: string;
  academic_year_next_id: string;
  kids_studying_count: string;
  order_count: number;
  schedule_copy_prev_available: boolean;
  municipality_id: string;
  municipality_name: string;
  partner_name: string;
  partner_id: string;
  partner_subordination_id: string;
}

type Id = string | number;
type StringOrNull = string | null;
type Subgroup = AxiosResponse<IGetEventSubgroup>;
type Subgroups = AxiosResponse<IGetEventSubgroups>;

export { SubgroupsPoints, Subgroups, Subgroup, Id, IGetEventSubgroups };



// WEBPACK FOOTER //
// ./src/services/subgroups/types.ts